export default {
  vertex: `
    precision mediump float;

    attribute vec2 vertPosition;
    attribute vec2 vertUV;
    uniform mat4 transformMatrix;
    varying vec2 quadUV;

    void main()
    {
      quadUV = vec2(vertUV);
      gl_Position = transformMatrix * vec4(vertPosition, 0.0, 1.0);
    }
  `,
  fragment: `
    precision mediump float;
    varying vec2 quadUV;
    uniform vec3 color;
    uniform float hardness;
    uniform float flow;
    uniform float brushSize;
    uniform float canvasSize;

    float rand(float n){return fract(sin(n) * 43758.5453123);}
    float noise(float p){
    	float fl = floor(p);
      float fc = fract(p);
    	return mix(rand(fl), rand(fl + 1.0), fc);
    }

    void main()
    {
      vec2 st = gl_FragCoord.xy;
      float dist = 0.0;

      // Radial Gradient
      dist = clamp(1.0-distance((quadUV-0.5)*2.0,vec2(0)),0.0,1.0);

      // Bellcurve remap
      float minStep = max(1.0 - hardness/100.0, (2.0/canvasSize)/(brushSize/canvasSize));

      // 0 = hard, 1 = soft
      dist = smoothstep(0.0,minStep,dist);

      gl_FragColor = vec4(color, dist*(flow/100.0));
    }
  `
};
